import React, { HTMLAttributes, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  padded?: boolean;
}

/**
 * Canonical card/panel shell used across the app. Replaces the mix of
 * `shadow rounded-lg`, `rounded-xl border ... p-6`, and ad hoc div wrappers
 * that previously coexisted.
 */
export const Card: React.FC<CardProps> = ({
  children,
  padded = true,
  className,
  ...props
}) => {
  return (
    <div
      className={twMerge(
        clsx(
          'rounded-xl border border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800',
          padded && 'p-5',
          className
        )
      )}
      {...props}
    >
      {children}
    </div>
  );
};

interface CardHeaderProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ children, className, ...props }) => (
  <div
    className={twMerge('px-5 py-4 border-b border-gray-100 dark:border-gray-700', className)}
    {...props}
  >
    {children}
  </div>
);
